import { z } from 'zod';
/** Route params for the staff endpoint that deletes a previsit form. */
export const PrevisitFormRemoveParamsSchema = z.object({ formId: z.uuid() }).strict();
/** Route params for the patient app endpoints addressing a single previsit form. */
export const PrevisitFormIdParamsSchema = z.object({ previsitFormId: z.uuid() }).strict();
/**
 * `score` is the single total the patient app has always sent; `scores` is the per-primitive map
 * that replaces it. Both are written while the two representations coexist, so neither is required.
 */
export const PrevisitFormScoreUpdateSchema = z
    .object({
    score: z.number().min(0).default(0),
    scores: z.record(z.string(), z.number().min(0)).optional(),
})
    .strict();
//# sourceMappingURL=form.js.map